import { useOrderFlowProperty } from 'utils/analytics/useOrderFlowProperty'

import { useEmbedPresetProperty } from '../entry/useEmbedPresetProperty'
import { usePfStore } from '../store'
import { usePfEmbed } from './usePfEmbed'

/**
 * Stamps the flow's events with the property the order is for, like legacy: the CRM's objectReferenceId inside the
 * embed (remembered, since in-flow navigation drops the URL's), and our realtyId: the CRM property's once its lookup
 * resolved (the property screen reports before it is chosen), else the chosen one. Shares the screen's lookup.
 */
export const usePfOrderFlowProperty = () => {
  const { propertyRef } = usePfEmbed()
  const preset = useEmbedPresetProperty(propertyRef)
  const chosenId = usePfStore((s) => s.property?.id ?? null)
  const realtyId = chosenId ?? (preset.status === 'ready' ? preset.property.id : null)

  useOrderFlowProperty({ objectReferenceId: propertyRef, realtyId })
}
